import { SVGIconComponent } from './types';

export const ProjectTypeProject: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="project-type/project" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M4.54937584,1.00080187 C4.80015892,1.00080187 5.10250463,1.10504883 5.30172508,1.25901737 L7.87355665,3.23895014 L14.1416336,3.23814827 C14.9393034,3.23814827 15.5869713,3.903744 15.5869713,4.721707 L15.5861901,6.51640535 L17.0088676,6.51640535 C17.3448117,6.51640535 17.6409073,6.66074572 17.8213776,6.91095486 C18.0018712,7.16118453 18.0479657,7.4939824 17.9487465,7.82437835 L15.2815138,16.7225282 C15.2322932,16.8869296 15.0838594,17 14.9158893,17 L0.303909931,17 C0.145313984,17 0.0164064014,16.8676835 0.0164064014,16.7048936 L0,2.48435936 C0,1.66639637 0.64844796,1.00080187 1.44533774,1 Z M4.51888227,2.37681952 L1.44544454,2.37681952 C1.38763183,2.37681952 1.34075526,2.42493572 1.34075526,2.48427725 L1.34075526,12.0752855 L2.72983231,7.44021658 C2.88531422,6.9221843 3.42048079,6.51640535 3.94860727,6.51640535 L14.2454883,6.51632323 L14.2463337,4.72162488 C14.2463337,4.66228335 14.1986131,4.61416716 14.1415804,4.61416716 L7.84390309,4.61416716 C7.59468003,4.61416716 7.29311633,4.51071878 7.09311387,4.35755293 L4.51888227,2.37681952 Z"
        id="Combined-Shape"
        fill="#848484"
        fillRule="nonzero"
      ></path>
    </g>
  </svg>
);
